import { IDashboardHeaderDataResponse } from "./dashboardApiSlice";

export enum ProductCode {
  EMPLOYEES_CARD_AND_LIST = "organization_structure_employees_card_and_list",
}

const isEmployeeCardEnabled = (
  products: IDashboardHeaderDataResponse["products"] | undefined
): boolean =>
  !!products?.some(
    (p) => p.code === ProductCode.EMPLOYEES_CARD_AND_LIST && p.isAvailable
  );
export default isEmployeeCardEnabled;
